class ConfigurationsOptionController {
    constructor(toastr, AppServiceApi, ModalService) {
        this.$onInit = function () {
            this.configurations = {};
            this.loadConfig();
        };
        this.loadConfig = () => {
            this.AppServiceApi.getAllConfigurations().then((response) => {
                let appConfigurations = response.data;
                this.configurations = appConfigurations;
            });
        };
        this.updateConfig = (config) => {
            let formFields = [
                {
                    'key': 'newKeyValue',
                    'type': 'input',
                    'defaultValue': config.Value,
                    'templateOptions': {
                        'type': 'text',
                        'label': 'New Value',
                        'placeholder': 'New Value',
                        'required': true,
                        'focus': true
                    }
                }
            ];
            let modalOptions = {
                actionButtonText: 'Ok',
                closeButtonText: 'Cancel',
                bodyText: '',
                headerText: 'Change Value for : ' + config.KeyName,
                formFields: formFields
            };
            this.ModalService.show({}, modalOptions).then((response) => {
                if (response.newKeyValue === undefined) {
                    response.newKeyValue = '';
                }
                let newConfig = {
                    Id: config.Id,
                    KeyName: config.KeyName,
                    Value: response.newKeyValue,
                    IsActive: true
                };
                this.AppServiceApi.updateConfiguration(newConfig).then((response) => {
                    if (response.data === true) {
                        this.loadConfig();
                        this.toastr.info('Configuration updated');
                    }
                    else {
                        this.toastr.error('Error saving changes, please contact system administrator!');
                    }
                });
            });
        };
        this.toastr = toastr;
        this.AppServiceApi = AppServiceApi;
        this.ModalService = ModalService;
    }
}
angular.module('app').component('configurationsOptions', {
    templateUrl: 'Scripts/App/partials/Features/configurations-options.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ConfigurationsOptionController
});
